import { FormControlLabel, Tooltip } from "@material-ui/core";
import React, { useCallback, useState } from "react";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { Checkbox } from "@mui/material";
import FormFieldBox from "../../DesignSystem/formFieldBox";
import InfoIcon from "../../../assets/images/info-icon.svg";
import Button from "../../DesignSystem/button";
import CheckboxIcon from "../../../assets/images/checkbox-unchecked.svg";
import CheckboxCheckedIcon from "../../../assets/images/checkbox-checked.svg";

interface AddNodeFormProps {
  type: "add" | "edit" | "closed";
  name: string;
  city: string;
  state: string;
  zip: string;
  street: string;
  country: string;
  longitude: string;
  latitude: string;
  originalNode?: any;
  showOnMap: boolean;
  setShowOnMap: (_: boolean) => void;
  setName: (_: any) => void;
  setCity: (_: any) => void;
  setState: (_: any) => void;
  setZip: (_: any) => void;
  setStreet: (_: any) => void;
  setCountry: (_: any) => void;
  setLongitude: (_: any) => void;
  setLatitude: (_: any) => void;
  addNode: () => void;
  submitEdits: () => void;
  onClose: () => void;
}
const AddNodeForm: React.FC<AddNodeFormProps> = ({
  type,
  name,
  city,
  state,
  zip,
  showOnMap,
  street,
  country,
  longitude,
  latitude,
  onClose,
  setName,
  setCity,
  setState,
  setZip,
  setStreet,
  setShowOnMap,
  setCountry,
  addNode,
  submitEdits,
  setLatitude,
  setLongitude,
  originalNode,
}) => {
  const hasNotChanged =
    originalNode &&
    originalNode.ne_name === name &&
    originalNode.city === city &&
    originalNode.state === state &&
    originalNode.zip === zip &&
    originalNode.street === street &&
    originalNode.country === country &&
    originalNode.latitude === latitude &&
    originalNode.longitude == longitude;
  const longLatNotReady = showOnMap && (!longitude || !latitude);
  const disabled = hasNotChanged || longLatNotReady || !name || !city || !state || !zip || !street || !country;
  const handleChange = (e: any, setter: any) => {
    e.stopPropagation();
    if (e.target.value) {
      setter(e.target.value);
    }
  };

  const generateFormField = useCallback((data: string, setter: any, id: string, text: string, placeholder = "", type = "text", tooltip = "") => {
    const onkeypress = (e: any) => !/[0-9.-]/.test(e.key) && type == "number" && e.preventDefault();
    return (
      <FormFieldBox excludeMarginTop excludeMarginBottom>
        <div className="text-area-root">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <label>
              {text}
              <span className={`asterisk ${id}`}>*</span>
            </label>
            {tooltip && (
              <Tooltip
                classes={{
                  tooltip: "tooltip",
                }}
                title={tooltip}
                arrow
                placement="right-start"
              >
                <img src={InfoIcon} alt="Info" />
              </Tooltip>
            )}
          </div>
          <div>
            <input onKeyPress={onkeypress} className="d-input" placeholder={placeholder} name={id} value={data} onChange={(e) => handleChange(e, setter)} />
          </div>
        </div>
      </FormFieldBox>
    );
  }, []);
  const title = type === "add" ? "Add Private Node" : "Edit Private Node";
  const buttonText = type === "add" ? "Add Private Node" : "Submit Edits";
  const buttonFunc = type === "add" ? addNode : submitEdits;
  return (
    <div className="add-node" onKeyUp={(e) => e.stopPropagation()} onKeyDown={(e) => e.stopPropagation()}>
      <div className="header" onClick={() => onClose()}>
        <ArrowBackIcon className="arrow" />
        <h1 className="title">{title}</h1>
      </div>
      <div className="body">
        {generateFormField(name, setName, "name", "Node Name", "", "text", "Please enter the display name for the node.")}
        {generateFormField(street, setStreet, "street", "Address", "")}
        <div className="two-col">
          {generateFormField(country, setCountry, "country", "Country", "")}
          {generateFormField(state, setState, "state", "State", "")}
        </div>
        <div className="two-col">
          {generateFormField(city, setCity, "city", "City", "")}
          {generateFormField(zip, setZip, "zip", "Zip", "", "number")}
        </div>
        <FormControlLabel
          control={
            <Checkbox
              color="default"
              checked={showOnMap}
              onChange={() => {
                setLongitude("");
                setLatitude("");
                setShowOnMap(!showOnMap);
              }}
              icon={<img style={{ paddingLeft: "10px" }} src={CheckboxIcon} alt="Checkbox" className="checkbox-icon" />}
              checkedIcon={<img style={{ paddingLeft: "10px" }} src={CheckboxCheckedIcon} alt="Checkbox Checked" className="checkbox-checked-icon" />}
            />
          }
          label="Show on map"
        />
        {showOnMap && (
          <div className="two-col">
            {generateFormField(latitude, setLatitude, "latitude", "Latitude", "", "number", "Negative number for south")}
            {generateFormField(longitude, setLongitude, "longitude", "Longitude", "", "number", "Negative number for west")}
          </div>
        )}
      </div>
      <div />
      <Button disabled={disabled} onClick={() => buttonFunc()} variant="primary" node={buttonText} />
    </div>
  );
};

export default AddNodeForm;
